import React from 'react'
import EventAppointment from './EventAppointment'
import CreneauContent from '../Creneau/CreneauContent'
import {
  useDispatch,
  useSelector
} from 'react-redux'
import {
  SELECTED_CRENEAU
} from '../../../Redux/Actions/Planning'

const EventAppointmentComponentRead = (props) => {
  const { data } = props
  const dispatch = useDispatch()
  const device = useSelector(state => state.device)
  const target = useSelector(state => state.planning.event)
  return (
    <EventAppointment
      onClick={() => {
        dispatch(SELECTED_CRENEAU(
          (data.id === target.id)
            ? {
                id: '',
                read: true
              }
            : {
                id: data.id,
                read: true,
                mobile: device.mobile
              }
        ))
      }}
      {...props}
    >
      <CreneauContent data={data}/>
    </EventAppointment>
  )
}

export default EventAppointmentComponentRead
